<template>
  
  <div class="single-customer">

    <section>
      <label>Utente</label>
      <span class="bold">{{customer.ragione_sociale}}</span>
    </section>

    <section>
      <label>Tipologia utente</label>
      <span class="bold">{{customer.ruolo.nome}}</span>
    </section>


    <section class="credentials">

      <button v-if="customer.cod_cli_for != 0" class="belt-btn-small" @click="visualizza_listino = true">visualizza listino</button>

      <button class="belt-btn-small" @click="manage_credentials = true">gestisci credenziali</button>

    </section>

    <credentials v-if="manage_credentials" :customer="customer"/>

    <b-modal v-model="visualizza_listino"
      :can-cancel="true">
      <template>
        <ListinoPrezzi :codclifor="customer.cod_cli_for" />
      </template>
    </b-modal>

  </div>

</template>

<script>
import Credentials from './credentials.vue'
import ListinoPrezzi from '../../listino-cliente.vue'
export default{

  components: {Credentials, ListinoPrezzi},
  props: ['customer'],

  data: function(){

    return {
      manage_credentials: false,
      visualizza_listino: false
    }

  }

}
</script>

<style scoped>
div.single-customer{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
div.single-customer section{
  width: 33.3333%;
  height: auto;
}
div.single-customer section label{
  display: block;
  width: 100%;
}
div.single-customer section.credentials{
  text-align: right;
}
</style>
